import React from 'react';
import PropTypes from 'prop-types';
import { KPITile } from './KPITile';
import styles from './KPITilesSection.module.css';

export const KPITilesSection = ({ categories }) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>KPI Status</h2>
      <div className={styles.list}>
        {categories.map((c) => (
          <KPITile 
            key={c.category} 
            category={c.category} 
            status={c.status} 
          />
        ))}
      </div>
    </div>
  );
};

KPITilesSection.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired
    })
  ).isRequired
};
